import { batch } from "@preact/signals-react"

import { clearAccountSignals } from "./account"
import { clearUserSettingAcrissCategorySignals } from "./acrissCategory"
import { clearUserSettingOfficesGroupSignals } from "./officesGroup"
import { clearUserSettingSitesProviderSignals } from "./sitesProviders"
import { clearUserSettingTierSignals } from "./tier"
import { clearSettingsTabs } from "./tabs"
import { clearUserSettingWebSupplierGroupSignals } from "./webSupplierGroup"


export {
	clearAccountSignals, identity, identityUser, identityOptions, identityState, identityError, identitySavedAt, loadIdentity, saveIdentity
} from "./account"
export { clearSettingsTabs, userSettingsTab, settingsLeaveGuards, registerLeaveGuard } from "./tabs"
export {
	clearUserSettingAcrissCategorySignals, isLoadingUserSettingsAcrissCategoryData, isLoadingUserSettingAcrissData, isLoadingUserSettingCategoryData,
	userSettingAcrissData, userSettingCategoryData, userSettingAcrissFormData, userSettingCategoryFormData, isOpenUserSettingsAcrissDrawer,
	isOpenUserSettingsCategoryDrawer, isEditUserSettingsAcrissDrawer, isEditUserSettingsCategoryDrawer
} from "./acrissCategory"
export { 
	clearUserSettingOfficesGroupSignals, isLoadingUserSettingOfficesGroupData, userSettingOfficesGroupData, userSettingsOfficesGroupFormData, 
	isOpenUserSettingsOfficesGroupDrawer, isEditUserSettingsOfficesGroupDrawer 
} from "./officesGroup"
export {
    clearUserSettingSitesGroupSignals, isLoadingUserSettingSitesGroupData, userSettingSitesGroupData, isEditUserSettingsSitesGroupDrawer,
    isOpenUserSettingsSitesGroupDrawer, userSettingsSitesGroupFormData
} from "./sitesGroup"
export {
	clearUserSettingSitesProviderSignals, isLoadingUserSettingsSitesProvidersData, isLoadingUserSettingProvidersData, isLoadingUserSettingSitesData, 
	userSettingSitesData, userSettingProvidersData, userSettingSitesFormData, userSettingProvidersFormData, isOpenUserSettingsSitesDrawer,
	isOpenUserSettingsProvidersDrawer, isEditUserSettingsSitesDrawer, isEditUserSettingsProvidersDrawer
} from "./sitesProviders"
export {
	clearUserSettingTierSignals, isLoadingUserSettingTierData, userSettingTierData, userSettingsTierFormData,
	isOpenUserSettingsTierDrawer, isEditUserSettingsTierDrawer
} from "./tier"
export {
	clearUserSettingWebSupplierGroupSignals, isLoadingUserSettingWebSupplierGroupData, userSettingWebSupplierGroupData,
	userSettingsWebSupplierGroupFormData, isOpenUserSettingsWebSupplierGroupDrawer, isEditUserSettingsWebSupplierGroupDrawer
} from "./webSupplierGroup"

// Functions
export const clearUserSettingsSignals = () => batch(() => {
	clearUserSettingAcrissCategorySignals()
	clearUserSettingOfficesGroupSignals()
	clearUserSettingSitesProviderSignals()
	clearUserSettingTierSignals()
	clearUserSettingWebSupplierGroupSignals()
	clearAccountSignals()
	clearSettingsTabs()
})